import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import Layout from 'sushiweb/Layout';
import ZImage from 'sushiweb/ZImage';
import PhotoViewer from 'sushiweb/PhotoViewer';
import { getFullDate } from '../../components/commons/CommonMethods';
import './imageViewer.scss';
import { Label } from '../../UiKit';

export const ImageViewer = ({ images }) => {
  const [ind, setInd] = useState(0);
  const [isOpen, toggleOpen] = useState(false);

  const handleClose = () => toggleOpen(false);

  const handleClick = (index) => (e) => {
    toggleOpen(true);
    setInd(index);
  };

  return (
    <div className='imageViewer'>
      <Layout gap={10}>
        {images.map((image, index) => {
          if (index === 0) {
            return (
              <React.Fragment key={index}>
                <Layout.Item colD={12} colT={12} colM={12}>
                  <ZImage
                    src={image.src}
                    width='100%'
                    height='200px'
                    style={{ borderRadius: '6px', cursor: 'pointer' }}
                    onClick={handleClick(index)}
                    alt='Sample image'
                    imgAlt='Sample image'
                  ></ZImage>
                  {image.image_ref && image.image_ref.created_at ? (
                    <div className='imageTimeWrapper'>
                      <p className='imageTime'>
                        {getFullDate(image.image_ref.created_at)}
                      </p>
                    </div>
                  ) : null}
                </Layout.Item>
                <Layout.Item colD={3} colT={3} colM={12}>
                  <div className='activeImage'>
                    <ZImage
                      src={image.src}
                      width='100%'
                      height='50px'
                      style={{
                        borderRadius: '6px',
                        cursor: 'pointer',
                        padding: '5px !important',
                      }}
                      onClick={handleClick(index)}
                      alt='Sample image'
                      imgAlt='Sample image'
                    />
                  </div>
                </Layout.Item>
              </React.Fragment>
            );
          }
          return (
            <Layout.Item colD={3} colT={3} colM={12}>
              <ZImage
                src={image.src}
                width='100%'
                height='50px'
                style={{
                  borderRadius: '6px',
                  cursor: 'pointer',
                  padding: '5px',
                }}
                onClick={handleClick(index)}
                alt='Sample image'
                imgAlt='Sample image'
              />
              {image.label ? (
                <span className='label'>
                  <Label
                    title={image.label}
                    bgColor='#256FEF'
                    showIcon={false}
                    fontSize={10}
                  />
                </span>
              ) : null}
            </Layout.Item>
          );
        })}
      </Layout>
      {ReactDOM.createPortal(
        <div
          css={`
            z-index: 10000;
            position: absolute;
          `}
        >
          <PhotoViewer
            isOpen={isOpen}
            handleClose={handleClose}
            data={images}
            currentIndex={ind}
            FooterNumbers={0}
          />
        </div>,
        document.body,
      )}
    </div>
  );
};

// render a photo viewer in react dom portal
